import { TrainerTypes } from "types/Trainer";
import ImagesUtils from "utils/images";
import { FunctionComponent } from "react";
import styled, { CSSProperties } from "styled-components";
import Flame from "components/Flame/Flame";
import variables from "theme/variables";

type OwnProps = {
  types: TrainerTypes[];
  size?: number;
  special?: boolean;
};
type Props = OwnProps;

const StyledTrainerTypes = styled.div`
  position: relative;
`;

const StyledTrainerType = styled.img`
  position: absolute;
`;

const StyledFlame = styled(Flame)`
  position: absolute;
  top: -50%;
  left: -25%;
`;

const colors = {
  INT: [44, 77, 22],
  MNT: [29, 63, 134],
  DEX: [144, 110, 21],
  SP: [85, 165, 235],
  GP: [155, 96, 231],
  STR: [184, 61, 48],
};

const TrainerType: FunctionComponent<Props> = ({ types, size = 30, special }) => {
  const images = types.map(ImagesUtils.getTypeImage);

  const style: CSSProperties = {
    width: `${size}px`,
    height: `${size}px`,
  };

  const typeStyle: CSSProperties = {
    left: "0",
  };

  if (special) {
    typeStyle.right = "0";
    typeStyle.margin = "auto";
  }

  return (
    <StyledTrainerTypes style={style}>
      {special && <StyledFlame size={size * 1.5} color={colors[types[0]] as [number, number, number]} />}

      {types.length === 2 && (
        <StyledTrainerTypes style={{ width: `${size}px`, height: `${size}px` }}>
          <StyledTrainerType
            src={images[0]}
            style={{ clipPath: "polygon(0% 0, 100% 0%, 0% 100%, 0 100%)", ...typeStyle }}
          />
          <StyledTrainerType
            src={images[1]}
            style={{ clipPath: "polygon(0% 100%, 100% 0%, 100% 100%,0% 100%)", ...typeStyle }}
          />
        </StyledTrainerTypes>
      )}

      {types.length === 1 && <StyledTrainerType src={images[0]} style={typeStyle} />}
    </StyledTrainerTypes>
  );
};

export default TrainerType;
